var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { defaultMapOptions } from '../constants';
import { getHexColor } from '../functions';
var GoogleMaps = function (_a) {
    var id = _a.id, className = _a.className, _b = _a.mapOptions, mapOptions = _b === void 0 ? {} : _b, _c = _a.center, center = _c === void 0 ? new window.google.maps.LatLng(31.3486073, 34.9622092) : _c, markers = _a.markers, onMapClick = _a.onMapClick, children = _a.children;
    var _d = useState(null), map = _d[0], setMap = _d[1];
    var mapRef = useRef(null);
    useEffect(function () {
        setMap(new google.maps.Map(mapRef.current, __assign(__assign(__assign({}, defaultMapOptions), mapOptions), { center: center })));
    }, []);
    useEffect(function () {
        if (!map || !onMapClick)
            return;
        var listener = map.addListener('click', onMapClick);
        return function () {
            listener.remove();
        };
    }, [map]);
    useEffect(function () {
        if (!mapOptions || !map)
            return;
        if (mapOptions.center)
            map.setCenter(mapOptions.center);
        if (mapOptions.zoom)
            map.setZoom(mapOptions.zoom);
    }, [mapOptions]);
    useEffect(function () {
        if (!map)
            return;
        var mapMarkers = markers.map(function (marker) {
            var markerColor = getHexColor(marker.color || 'red').substring(1);
            var mapMarker = new google.maps.Marker({
                position: new google.maps.LatLng(marker.lat, marker.lng),
                icon: "https://mt.googleapis.com/vt/icon/name=icons/onion/SHARED-mymaps-pin-container-bg_4x.png,icons/onion/SHARED-mymaps-pin-container_4x.png,icons/onion/1899-blank-shape_pin_4x.png&highlight=ff000000," + markerColor + "&scale=" + (marker.selected ? 2 : 1.2),
                map: map
            });
            marker.onClick && mapMarker.addListener('click', marker.onClick);
            return mapMarker;
        });
        return function () {
            for (var _i = 0, mapMarkers_1 = mapMarkers; _i < mapMarkers_1.length; _i++) {
                var mapMarker = mapMarkers_1[_i];
                mapMarker.setMap(null);
            }
        };
    }, [map, markers]);
    return (_jsxs("div", __assign({ id: id, className: className }, { children: [children, _jsx("div", { ref: mapRef, style: { width: '100%', height: 'calc(100% + 2rem)' } }, void 0)] }), void 0));
};
export default GoogleMaps;
//# sourceMappingURL=GoogleMaps.js.map